// extracted by mini-css-extract-plugin
export default {"formElementsContainer":"IssueFormElements-module__formElementsContainer__J_DMJY3","markdownElementWrapper":"IssueFormElements-module__markdownElementWrapper__E0mmFn4"};